module.exports = {"TXTCLI_LoadingXX_Please_wait":{"id":"TXTCLI_LoadingXX_Please_wait","defaultMessage":"読み込み中…お待ちください"}}